import axios from "axios";
import { baseURL } from "../../../base-url.js";

export default {
  async getBoard({ commit }, userId) {
    const token = localStorage.getItem("jwt");
    try {
      const response = await axios.get(`${baseURL}/employee/getBoard`, {
        params: { 
          id: userId
         },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }); 
      commit("setBoard", response.data);
    } catch (error) {
      console.error("Błąd ładowania board:", error);
    }
  },

  async updateBoard(_, { id, boardNotes }) {
    const token = localStorage.getItem("jwt");
    try {
      const response = await axios.put(
        `${baseURL}/employee/updateBoard`,
        boardNotes,
        {
          params: { id },
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'text/plain'
          }
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },

  async getAllAdmins() {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.get(`${baseURL}/user/getAllAdmins`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Błąd ładowania administratorów:", error);
      throw error;
    }
  },

  async changePassword(_, { oldPassword, newPassword }) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.put(
        `${baseURL}/user/changePassword`,
        {
          oldPassword,
          newPassword
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  }

}
